import { c as _c } from "react/compiler-runtime";
import { Boxes } from "@website/ticket-ui/visa/boxes";
import { Documents } from "@website/ticket-ui/visa/documents";
import { Faq } from "@website/ticket-ui/visa/faq";
import { Tables } from "@website/ticket-ui/visa/tables";
import { Timeline } from "@website/ticket-ui/visa/timeline";
import { VisaForm } from "@website/ticket-ui/visa/visaForm";
import { Tabs } from "@website/ui/tabs";
import { Channels } from "@website/utils/channel/types";
import { Footer } from "@website/widget/footer";
import { Header } from "@website/widget/header";
import { NextPage } from "next";
import { useRouter } from "next/router";
import { FAQS } from "../../config/faq";
import { COUNTRIES } from "../../config/visas";
import VisaDesktop from "../../public/images/visa-desktop.png";
import SearchNoResult from "../../public/images/visa.png";
import type { VisaPriceTableResponse, VisaTypesResponse } from "../../types/responses";
type VisaProperties = {
  visaTypes: VisaTypesResponse["Items"];
  priceTableData: VisaPriceTableResponse["items"];
  channel?: Channels;
};
const Visa: NextPage<VisaProperties> = properties => {
  const $ = _c(37);
  const router = useRouter();
  const {
    country: countryName
  } = router.query;
  let t0;
  if ($[0] !== countryName) {
    t0 = COUNTRIES.find(country => country.name === countryName);
    $[0] = countryName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const selectedCountry = t0;
  if (selectedCountry === undefined) {
    return "\u0645\u0634\u06A9\u0644\u06CC \u067E\u06CC\u0634 \u0622\u0645\u062F.";
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Header />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="max-sm:border-outline-thin flex justify-center bg-[#EFF9FE] max-sm:border-y"><img alt="no result" className="sm:hidden" height={134} src={SearchNoResult.src} width={360} /><img alt="no result" className="hidden sm:block" height={208} src={VisaDesktop.src} width={1200} /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = selectedCountry?.faName;
  let t4;
  if ($[4] !== t3) {
    t4 = <h1 className="text-on-surface-high-emphasis text-subtitle-1 md:text-headline-6 pb-2 pt-3 md:p-0">ویزای توریستی {t3}</h1>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== properties.visaTypes || $[7] !== selectedCountry) {
    t5 = <VisaForm selectedCountry={selectedCountry} visaTypes={properties.visaTypes} />;
    $[6] = properties.visaTypes;
    $[7] = selectedCountry;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex w-full justify-center"><div className="md:border-outline-thin md:shadow-6 flex-1 md:rounded-lg md:border md:px-10 md:py-8">{t4}{t5}</div></div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="bg-outline-thin h-px w-full sm:hidden" role="separator" />;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = selectedCountry?.details;
  let t9;
  if ($[13] !== t8) {
    t9 = <Boxes countryDetails={t8} />;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      title: "\u0645\u0631\u0627\u062D\u0644 \u0627\u062E\u0630",
      panel: <Timeline />
    };
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== properties.priceTableData) {
    t11 = <Tables priceTableData={properties.priceTableData} />;
    $[16] = properties.priceTableData;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ul className="pb-1 pt-6"><li className="text-body-2 mr-6 list-disc py-1">تمامی هزینه‌های ویزا به صورت معادل ریالی ایران دریافت می شود.</li></ul>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11) {
    t13 = {
      title: "\u062C\u062F\u0648\u0644 \u0642\u06CC\u0645\u062A\u06CC",
      panel: <div>{t11}{t12}</div>
    };
    $[19] = t11;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = selectedCountry?.documents;
  let t15;
  if ($[21] !== t14) {
    t15 = {
      title: "\u0645\u062F\u0627\u0631\u06A9 \u0645\u0648\u0631\u062F \u0646\u06CC\u0627\u0632",
      panel: <Documents documents={t14} />
    };
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t13 || $[24] !== t15) {
    t16 = <Tabs size="fill" tabs={[t10, t13, t15]} variant="underline" />;
    $[23] = t13;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="bg-outline-thin h-px w-full" role="separator" />;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== selectedCountry?.countryCode) {
    t18 = FAQS[selectedCountry?.countryCode] && <Faq data={FAQS[selectedCountry?.countryCode]} />;
    $[27] = selectedCountry?.countryCode;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== t16 || $[30] !== t18 || $[31] !== t6 || $[32] !== t9) {
    t19 = <div className="m-auto max-w-[1200px]">{t2}<div className="m-auto flex max-w-screen-lg flex-col gap-10 pb-6 max-sm:gap-6 max-sm:px-6">{t6}{t7}{t9}{t16}{t17}{t18}</div></div>;
    $[29] = t16;
    $[30] = t18;
    $[31] = t6;
    $[32] = t9;
    $[33] = t19;
  } else {
    t19 = $[33];
  }
  let t20;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Footer />;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== t19) {
    t21 = <div>{t1}{t19}{t20}</div>;
    $[35] = t19;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  return t21;
};
export default Visa;
export { getServerSideProps } from "./server";